"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGlobalEventBus = exports.getGlobalEventBus = exports.initGlobalEventBus = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "initGlobalEventBus", { enumerable: true, get: function () { return features_1.initGlobalEventBus; } });
Object.defineProperty(exports, "getGlobalEventBus", { enumerable: true, get: function () { return features_1.getGlobalEventBus; } });
Object.defineProperty(exports, "setGlobalEventBus", { enumerable: true, get: function () { return features_1.setGlobalEventBus; } });
//# sourceMappingURL=index.js.map